import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-pricing-popup',
  standalone: true,
  imports: [],
  templateUrl: './pricing-popup.component.html',
  styleUrl: './pricing-popup.component.scss'
})
export class PricingPopupComponent {
  @Input() pricingPopupVisible = false;
  @Output() closePricingPopupEvent = new EventEmitter<void>();
  closePricingPopup() {
    this.closePricingPopupEvent.emit();
  }

}
